import { render, staticRenderFns } from "./ListAllTeachers.vue?vue&type=template&id=0b282c7c&"
import script from "./ListAllTeachers.vue?vue&type=script&lang=js&"
export * from "./ListAllTeachers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports